import { SessionCart, useCart } from 'lib/cart';
import { useState } from 'react';

const useBuildNewOrder = () => {
  const { refreshCart, cart } = useCart();
  const [isLoading, setIsLoading] = useState(false);
  const [
    showBuildNewOrderModal,
    setShowBuildNewOrderModal,
  ] = useState(false);

  const onBuildNewOrder = async (
    clearCart: boolean,
    {
      onSuccess,
      onError,
    }: {
      onSuccess: () => void;
      onError?: (message: string) => void;
    },
  ) => {
    try {
      setIsLoading(true);
      if (clearCart) {
        await SessionCart.createNewCart({ isGuest: false });
        await refreshCart();
      }
      onSuccess();
    } catch (err) {
      onError?.(
        err.message ?? 'Something went wrong! Please try again.',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    onBuildNewOrder,
    showBuildNewOrderModal,
    setShowBuildNewOrderModal,
    quantity: cart?.quantity ?? 0,
  };
};

export default useBuildNewOrder;
